import React from 'react';

import {StreamBankLink} from './StreamBankLink';

import {service as ContextNodeService} from "../../Services/ContextNodeService";
import {useGetUrlToolSegment} from "../../Hooks/RouteHooks";
import {useFetchContextNode} from "../../Hooks/ContextHooks";

export const ContextNodeLink = function (props) {
    const {contextNode:contextNodeFromProps = null, contextNodeId, useShortName = null} = props;

    const getUrlToolSegment = useGetUrlToolSegment();
    const contextNode = useFetchContextNode(contextNodeId, contextNodeFromProps);
    
    const link = ((contextNode?.link ?? '') + '/') + getUrlToolSegment();
    const title = useShortName ?
        ContextNodeService.GetShortTitle(contextNode) :
        ContextNodeService.GetTitle(contextNode);

    return <StreamBankLink className="sb-context-node-link" Href={link}>{title}</StreamBankLink>;
};
